
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/your-grief-journey",
      function () {
        return require("private-next-pages/your-grief-journey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/your-grief-journey"])
      });
    }
  